<template>
  <h6 class="mb-1">{{ order }}) {{ freeField1 }}</h6>
  <p>{{ freeField2 }}</p>
  <div class="form-group">
    <textarea
      class="form-control"
      rows="4"
      placeholder="Digite aqui..."
      v-model="value"
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'OpenAnswerTextArea',

  props: {
    order: {
      type: [String, Number],
      default: '1',
    },
    freeField1: {
      type: String,
      default: 'Deixe seu feedback',
    },
    freeField2: {
      type: String,
      default: '',
    },
    freeField3: {
      type: String,
      default: '',
    },
    userDistribution: {
      type: Object,
      default: null,
    },
  },

  emits: ['setValue'],

  data() {
    return {
      value: '',
    }
  },

  methods: {
    handleInput() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.setValue()
      }, 2000)
    },

    setValue() {
      if (this.userDistribution) {
        const newUserDistribution = { ...this.userDistribution }
        newUserDistribution.value = this.value
        this.$emit('setValue', newUserDistribution)
      }
    },
  },

  mounted() {
    if (this.userDistribution) {
      this.value = this.userDistribution.value
    }
  },
}
</script>
